export default "__VITE_ASSET__d1b49e2a__"